import axios from "axios"

class ICalAPI {
  getICalUrls = async () => {
    return axios.get(`api/ical-urls`)
  }
}

export const iCal = new ICalAPI()
